import './WatchFinderApp.less';
import React, {useState, useEffect, useRef} from 'react';
import WatchWristDiscoverTool from '../../tools/watch-wrist-discover/WatchWristDiscoverTool';
import StrapSelectTool from '../../tools/strap-select/StrapSelectTool';
import Request from '../../../api/Request';
import StrapCandidateRecommendedParcel from '../../endpoints/strap-candidate/StrapCandidateRecommendedParcel';
import __ from '../../../i18n';
import WatchCandidateListParcel from "../../../api/endpoints/watch-candidate/WatchCandidateListParcel";


export default function WatchFinderApp({
    wristPrototypes,
    wristImages,
    productAttributes,
    productAttributeGroups,
    wristSizeMeasurementUrl,
    cartHandler,
}) {
    const [watchCandidateData, setWatchCandidateData] = useState({
        candidate: null,
        images: []
    });

    const [selectedStrapCandidateData, setSelectedStrapCandidateData] = useState({
        candidate: null,
        images: []
    });

    const [recommendedStrapCandidatesData, setRecommendedStrapCandidatesData] = useState({
        candidates: null,
        images: []
    });

    const isManuallySelectedStrapRef = useRef(false);

    const requestWatchCandidate = (productId, productOptionId) => {
        Request.add(new WatchCandidateListParcel(
            [
                {field: 'product_id', operator: '=', value: productId},
                {field: 'product_option_id', operator: '=', value: productOptionId},
            ],
            {
                product_id: {type: 'number'},
                product_option_id: {type: 'number'},
            },
            null,
            1,

        )).then(data => {
            if (data.items.length === 0) {
                return;
            }

            setWatchCandidateData({
                candidate: data.items[0],
                images: data.relations.image
            });

        }).catch(error => {

            console.log(error.getMessage());

            setWatchCandidateData({
                candidate: null,
                images: []
            });
        });
    };

    useEffect(() => {
        if (watchCandidateData.candidate === null) {
            return;
        }

        Request.add(new StrapCandidateRecommendedParcel(watchCandidateData.candidate.id))
            .then(setRecommendedStrapCandidatesData);

    }, [watchCandidateData.candidate && watchCandidateData.candidate.id]);

    const allImages = recommendedStrapCandidatesData.images
        .concat(watchCandidateData.images)
        .concat(selectedStrapCandidateData.images);

    return <div className="watch-finder-app">
        <div className="sub-heading">
            <h2 className="title">
                {__('Select your own watch')}
            </h2>
            <div className="description">
                {__('Try with your wrist size and some straps to choose the most pleasing watch')}
            </div>
        </div>

        <WatchWristDiscoverTool
            wristPrototypes={wristPrototypes}
            images={wristImages}
            productAttributes={productAttributes}
            productAttributeGroups={productAttributeGroups}
            wristSizeMeasurementUrl={wristSizeMeasurementUrl}
            cartHandler={cartHandler}
            onChangeProductWatchPrototype={(productPrototype, images) => {
                if (productPrototype !== null) {
                    requestWatchCandidate(productPrototype.product_id, productPrototype.product_option_id);
                }

                setWatchCandidateData({candidate: null, images: []});
            }}
        />

        {
            watchCandidateData.candidate !== null &&
            recommendedStrapCandidatesData.candidates !== null &&
            <>
                <div className="sub-heading">
                    <h2 className="title">
                        {__('Select a strap')}
                    </h2>
                    <div className="description">
                        {__('Try the watch you selected with some straps')}
                    </div>
                </div>
                <StrapSelectTool
                    key={watchCandidateData.candidate.id + ';' + (recommendedStrapCandidatesData.candidates || []).map(t => t.id)}
                    specificWatchCandidate={watchCandidateData.candidate}
                    defaultSelectedStrapCandidate={isManuallySelectedStrapRef.current ? selectedStrapCandidateData.candidate : null}
                    recommendedStrapCandidates={recommendedStrapCandidatesData.candidates || undefined}
                    images={allImages}
                    cartHandler={cartHandler}
                    onManualActionEnd={() => {
                        isManuallySelectedStrapRef.current = true;
                    }}
                    onChangeProductStrapCandidate={(candidate, images) => {
                        setSelectedStrapCandidateData({candidate, images});
                    }}
                />
            </>
        }
    </div>;
}

